import TimeTagWatch from "../../views/portfolio/TimeTagWatch";
import UnderArmour from "../../views/portfolio/UnderArmour";
import ReStyling from "../../views/portfolio/ReStyling";
// import ToastReel from "../../views/portfolio/ToastReel";
// import WhatIfGold from "../../views/portfolio/WhatIfGold";
// import NileKabutha from "../../views/portfolio/NileKabutha";
// import SleepWalker from "../../views/portfolio/SleepWalker";
// import NovaraConic from "../../views/portfolio/NovaraConic";
// import BastianBux from "../../views/portfolio/BastianBux";
import World from "../../views/World";

const labelsData = [
  {
    name: "The Sanctuary",
    lat: -20.287991865417286,
    lon: 13.577213287353517,
  },
  {
    name: "The High Road",
    lat: -18.791111382840445,
    lon: 0.15380859375000003,
  },
  {
    name: "The High Tower",
    lat: -12.054418548353937,
    lon: -24.235324859619144,
  },
];

const chaptersData = [
  {
    id: 1,
    title: "The Sanctuary",
    slug: "the-sacntuary",
    caption: "Chapter 1",
    category: ["Meditation"],
    description:
      "The world beyond this place still rushes and roars, but it need not follow you here",
    src: "/assets/img/project/01-the-sanctuary/main.jpg",
    srcSlider: "/assets/img/project/01-the-sanctuary/side.jpg",
    overlay: 2,
    buttonText: "Begin Quest",
    link: "https://youtu.be/SZ0l08Tmlvc?si=6j4oJ5GW3if-ELy1",
    component: (props) => <TimeTagWatch {...props} />,
    lat: -20.34462694382967,
    lon: 13.579101562500002,
    imageUrl: "/assets/img/project/01-the-sanctuary/7.jpg",
  },
  {
    id: 2,
    title: "The High Road",
    slug: "the-high-road",
    caption: "Chapter 2",
    src: "/assets/img/project/02-the-high-road/main.jpg",
    srcSlider: "/assets/img/project/02-the-high-road/side.jpg",
    category: ["Meditation"],
    buttonText: "Begin Quest",
    link: "https://youtu.be/aUxtoaRztA4?si=WF20oKdgYY4a010b",
    description:
      "Let's ride together in the high Road. We are stronger together.",
    overlay: 2,
    component: (props) => <UnderArmour {...props} />,
    lat: -18.721373250591363,
    lon: -0.1405906677246094,
  },
  {
    id: 3,
    title: "The High Tower",
    slug: "the-high-tower",
    caption: "Chapter 3",
    src: "/assets/img/project/03-the-high-tower/main.jpg",
    srcSlider: "/assets/img/project/03-the-high-tower/side.jpg",
    category: ["Meditation"],
    buttonText: "Begin Quest",
    link: "https://youtu.be/9qOyH_pIc14?si=X5GDAXrl2OVzzT6O",
    description:
      "Welcome to the high tower my friend. Here even the wind rests.",
    overlay: 2,
    component: (props) => <UnderArmour {...props} />,
    lat: -16.925047796494706,
    lon: -26.544857025146488,
  },
];

const musicData = [
  {
    //https://www.youtube.com/embed/ap3XjPjnSWc?si=VsQoVOygR7vbs8IR
    id: 3,
    title: "I Knew You Were Real",
    caption: "Music",
    slug: "i-knew-you-were-real",
    src: "/assets/img/music/01-i-knew-you-were-real/main.jpg",
    srcSlider: "/assets/img/music/01-i-knew-you-were-real/side.jpg",
    category: ["Music"],
    description:
      "I knew you were real, I just didn't know how much I needed you.",
    overlay: 2,
    buttonText: "Listen Now",
    link: "https://open.spotify.com/track/7uP3jCIb2J7iQ30qKbBnHR?si=c325bfb4fa6f4cc3",
    component: (props) => <ReStyling {...props} />,
    lat: -25.409512051967805,
    lon: 24.185714721679688,
  },
];

const data = [
  {
    id: 0,
    title: "Welcome Traveler",
    slug: "map",
    src: "/assets/img/traveler.jpg",
    caption: "Greetings",
    srcSlider: "/assets/img/traveler.jpg",
    description:
      "Ancient paths wind through hidden realms. Only those who watch closely will see their wonders.",
    overlay: 2,
    buttonText: "Explore the Lands",
    link: "/map",
    component: (props) => <World {...props} />,
  },
  ...chaptersData,
  ...musicData,
  // {
  //   id: 4,
  //   title: "Toast 2019 Reel",
  //   slug: "toast-2019-reel",
  //   category: ["Video"],
  //   src: "https://theme.dsngrid.com/video/droow.mp4",
  //   video: {
  //     poster: "/assets/img/project/project4/1.jpg",
  //     loop: true,
  //   },
  //   description:
  //     "We are thrilled to share our new reel with you all! Special thanks to all of our talented friends.",
  //   overlay: 2,
  //   component: (props) => <ToastReel {...props} />,
  // },
  // {
  //   id: 5,
  //   title: "What If Gold",
  //   slug: "what-if-gold",
  //   src: "/assets/img/project/project5/1.jpg",
  //   // srcSlider: '/assets/img/project/project5/2.jpg',
  //   category: ["Brand", "Photography"],
  //   description:
  //     "Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.",
  //   overlay: 2,
  //   component: (props) => <WhatIfGold {...props} />,
  // },
  // {
  //   id: 6,
  //   title: "Nile - Kabutha",
  //   slug: "nile-kabutha",
  //   category: ["Photography", "Brand"],
  //   src: "/assets/img/project/project6/1.jpg",
  //   // srcSlider: '/assets/img/project/project6/2.jpg',
  //   description:
  //     "Striking and powerful Aston Martin Vantage captivates you at the first sight.",
  //   overlay: 2,
  //   component: (props) => <NileKabutha {...props} />,
  // },
  // {
  //   id: 7,
  //   title: "Sleep Walker",
  //   slug: "sleep-walker",
  //   category: ["Photography"],
  //   src: "/assets/img/project/project7/1.jpg",
  //   // srcSlider: '/assets/img/project/project7/4.jpg',
  //   description:
  //     "Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.",
  //   overlay: 2,
  //   component: (props) => <SleepWalker {...props} />,
  // },
  // {
  //   id: 8,
  //   title: "Novara Conic",
  //   slug: "novara-conic",
  //   src: "/assets/img/project/project8/1.jpg",
  //   // srcSlider: '/assets/img/project/project8/4.jpg',
  //   category: ["Architecture"],
  //   description:
  //     "Cal was first. The first public university in the great state of California. They are the pioneers.",
  //   overlay: 2,
  //   component: (props) => <NovaraConic {...props} />,
  // },
  // {
  //   id: 9,
  //   title: "Bastian Bux",
  //   slug: "bastian-bux",
  //   category: ["Photography"],
  //   description:
  //     "Bastian bux is the consequence of reducing everything surrounding a dj and producer to its essential element: the music.",
  //   src: "/assets/img/project/project9/1.jpg",
  //   // srcSlider: '/assets/img/project/project9/3.jpg',
  //   overlay: 2,
  //   component: (props) => <BastianBux {...props} />,
  // },
];

export const getPortfolioData = () => data;
export const getChaptersData = () => chaptersData;
export const getMusicData = () => musicData;
export const getLabelsData = () => labelsData;

export const getPortfolioItem = (value, whereName = "id") => {
  return data.find((item) => {
    if (item[whereName] === value) return item;
    return null;
  });
};
export const getPortfolioLink = (item) => {
  if (item) return item.slug && "/portfolio/" + item.slug;

  return "";
};
